module.exports = __webpack_public_path__ + "img/close-white-24dp.47f3420a.svg";